// @ts-nocheck
/**
 * Collection page and search results (sections/vhp-main-collection.liquid): a tap on a recipe card plays the list in
 * the video reel (assets/vhp-reel-viewer.js) on top of the page, from that recipe, as Explore's row tiles do; swiping
 * goes on through the same recipes:
 *  - Collection without filters or sort: the whole collection in its order (/collections/{handle}?view=reel-index),
 *    also the recipes the grid has not loaded yet.
 *  - Filtered, sorted or search results: the cards on the page, in their order.
 * Without the viewer (or on any failure) the card's link opens the recipe page as before.
 */
(() => {
  'use strict';

  if (window.__vhpCollectionGridReel) return;
  window.__vhpCollectionGridReel = true;

  const tr = window.vhpT; // snippets/vhp-i18n.liquid
  // How long a tap waits for the whole collection before it plays the loaded cards instead.
  const INDEX_WAIT_MS = 1500;

  const track = (name, params) => {
    if (typeof window.vhpTrack === 'function') window.vhpTrack(name, params);
  };
  const num = (value) => (value === '' || value == null || !Number.isFinite(Number(value)) ? null : Number(value));

  const cardOf = (target) => {
    const card = target instanceof Element ? target.closest('#recipeGrid .recipe-card[data-handle]') : null;
    const section = card?.closest('[data-listing-mode]');
    return card && section ? { card, section } : null;
  };

  const cardItem = (card) => ({
    id: card.dataset.id || '',
    handle: card.dataset.handle,
    title: card.dataset.title || '',
    image: card.dataset.poster || card.dataset.image || '',
    protein: num(card.dataset.protein),
    time: num(card.dataset.time),
    kcal: num(card.dataset.kcal),
  });

  // The whole collection only when the grid shows it as it is: no filter, sort or search in the URL.
  const wholeCollection = (section) => {
    const handle = section.dataset.reelCollection;
    if (!handle) return '';
    const params = new URLSearchParams(location.search);
    for (const key of params.keys()) if (key.startsWith('filter.') || key === 'sort_by' || key === 'q') return '';
    return handle;
  };

  const withTimeout = (promise, ms) =>
    Promise.race([promise, new Promise((_, reject) => window.setTimeout(() => reject(new Error('timeout')), ms))]);

  let opening = 0;
  const open = async ({ card, section }) => {
    const token = ++opening;
    const viewer = window.vhpReelViewer;
    const grid = section.querySelector('#recipeGrid');
    const onPage = Array.from(grid.querySelectorAll('.recipe-card[data-handle]')).map(cardItem);
    const start = card.dataset.handle;
    const handle = wholeCollection(section);
    let items = onPage;
    card.classList.add('is-opening');
    try {
      if (handle) {
        const all = await withTimeout(viewer.collection(handle), INDEX_WAIT_MS).catch(() => null);
        if (all?.some((item) => item.handle === start)) items = all;
      }
    } finally {
      card.classList.remove('is-opening');
    }
    if (token !== opening || !section.isConnected) return;
    const index = Math.max(0, items.findIndex((item) => item.handle === start));
    const title = section.dataset.reelTitle || '';
    // Background card videos rest while the reel plays; the ones paused here start again after it.
    const paused = Array.from(grid.querySelectorAll('video')).filter((video) => !video.paused);
    paused.forEach((video) => video.pause());
    track('collection_reel_open', { collection: section.dataset.reelCollection || '', whole: Boolean(handle && items !== onPage), start, size: items.length });
    viewer.open({
      items,
      start: index,
      title: title || undefined,
      label: tr('explore.as_videos', { title: title || tr('search.tab_recipes') }),
      source: section.dataset.reelCollection ? 'collection_grid' : 'search_grid',
      ...(section.dataset.subscriber === 'true' && window.vhpPlanPicker
        ? { onPlan: (item) => window.vhpPlanPicker.open(item, { source: 'collection_reel' }) }
        : {}),
      originFor: (item) => grid.querySelector(`.recipe-card[data-handle="${CSS.escape(item.handle)}"]`),
      onClose: () => paused.forEach((video) => video.play().catch(() => {})),
    });
  };

  // Finger down on a card: the collection list and the first video start loading.
  document.addEventListener(
    'pointerdown',
    (event) => {
      const hit = cardOf(event.target);
      const viewer = window.vhpReelViewer;
      if (!hit || !viewer) return;
      const handle = wholeCollection(hit.section);
      if (handle) viewer.collection(handle).catch(() => {});
      viewer.prefetch(hit.card.dataset.handle);
    },
    { passive: true }
  );

  // Capture phase: the card's video (deferred-media) stops its own clicks before they bubble. Real taps only: the
  // card video autoplay (vhp-recipe-card-video-autoplay.js) starts videos with a scripted click on the same button.
  document.addEventListener(
    'click',
    (event) => {
      const plain = event.isTrusted && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0;
      const hit = plain ? cardOf(event.target) : null;
      if (!hit || !window.vhpReelViewer) return;
      event.preventDefault();
      event.stopPropagation();
      open(hit).catch(() => {
        const href = hit.card.querySelector('.recipe-card__link')?.href;
        if (href) window.location.href = href;
      });
    },
    true
  );
})();
